/* eslint-disable */

// This is a generated file and SHOULD NOT BE EDITED MANUALLY!!
// Contents are generated as part of grunt build
// Source of truth is lib/cdo/shared_constants.rb and files in lib/cdo/shared_constants/

export const PublishedState = {
  "in_development": "in_development",
  "pilot": "pilot",
  "beta": "beta",
  "preview": "preview",
  "stable": "stable",
  "sunsetting": "sunsetting",
  "deprecated": "deprecated"
};

export const InstructionType = {
  "teacher_led": "teacher_led",
  "self_paced": "self_paced"
};

export const ParticipantAudience = {
  "facilitator": "facilitator",
  "teacher": "teacher",
  "student": "student"
};

export const InstructorAudience = {
  "universal_instructor": "universal_instructor",
  "plc_reviewer": "plc_reviewer",
  "facilitator": "facilitator",
  "teacher": "teacher"
};

export const CurriculumUmbrella = {
  "CSF": "CSF",
  "CSD": "CSD",
  "CSP": "CSP",
  "CSA": "CSA",
  "CSC": "CSC",
  "HOC": "HOC",
  "CSA_self_paced_pl": "CSA Self Paced PL",
  "CSP_self_paced_pl": "CSP Self Paced PL",
  "CSD_self_paced_pl": "CSD Self Paced PL",
  "CSF_self_paced_pl": "CSF Self Paced PL",
  "CSP_virtual_pl": "CSP Virtual PL",
  "CSD_virtual_pl": "CSD Virtual PL",
  "CSA_virtual_pl": "CSA Virtual PL",
  "student_self_paced": "Student Self Paced Courses"
};

export const CourseOfferingCategories = [
  "pl_self_paced",
  "pl_virtual",
  "pl_other",
  "full_course",
  "csf",
  "csc",
  "aiml",
  "maker",
  "hoc",
  "csf_international",
  "math",
  "twenty_hour",
  "other"
];

export const CourseOfferingCurriculumTypes = {
  "module": "Module",
  "course": "Course",
  "standalone_unit": "Standalone Unit",
  "hoc": "Hour of Code",
  "pl": "Professional Learning"
};

export const CourseOfferingHeaders = {
  "favorites": "Favorites",
  "labs_and_skills": "Labs and Skills",
  "minecraft": "Minecraft",
  "hello_world": "Hello World",
  "popular_media": "Popular Media",
  "sports": "Sports",
  "express": "Express",
  "csf": "CS Fundamentals",
  "csc": "CS Connections",
  "year_long": "Year Long",
  "csa_labs": "CSA Labs",
  "self_paced": "Self-Paced",
  "teacher_led": "Teacher-Led",
  "collections": "Collections",
  "workshops_k5": "K-5 Workshops",
  "summer_workshops_612": "6-12 Summer Workshops",
  "virtual_academic_year_workshops_612": "6–12 Virtual Academic Year Workshops",
  "unsupported": "Unsupported"
};

export const CourseOfferingMarketingInitiatives = {
  "hoc": "HOC",
  "csc": "CSC",
  "csf": "CSF",
  "csa": "CSA",
  "csp": "CSP",
  "csd": "CSD"
};

export const CourseOfferingCsTopics = [
  "art_and_design",
  "app_design",
  "artificial_intelligence",
  "cybersecurity",
  "data",
  "digital_literacy",
  "games_and_animations",
  "internet",
  "physical_computing",
  "web_design",
  "programming"
];

export const CourseOfferingSchoolSubjects = [
  "math",
  "science",
  "english_language_arts",
  "history"
];

export const DeviceTypes = [
  "computer",
  "chromebook",
  "tablet",
  "mobile",
  "no_device"
];

export const DeviceCompatibilityLevels = [
  "ideal",
  "not_recommended",
  "incompatible"
];

export const ParticipantAudiencesByType = {
  "student": [
    "student"
  ],
  "teacher": [
    "student",
    "teacher"
  ],
  "facilitator": [
    "student",
    "teacher",
    "facilitator"
  ]
};
